import { Response } from '@marketplace-web/core-api/api-client-util'

import { AddressEntryType } from '../constants'
import {
  AddressDto,
  AddressModel,
  AddShippingAddressArgs,
  AddShippingOrderAddressArgs,
  AddUserAddressArgs,
  DefaultShippingAddressResp,
} from '../types/address'

export const transformAddress = (address: AddressDto): AddressModel => ({
  id: address.id,
  userId: address.user_id,
  entryType: address.entry_type,
  countryId: address.country_id,
  isDefault: address.is_default === 1,
  isDeleted: address.is_deleted,
  isComplete: address.is_complete,
  cityId: address.city_id,
  name: address.name,
  createdAt: address.created_at,
  country: address.country,
  city: address.city,
  updatedAt: address.updated_at,
  externalCode: address.external_code,
  latitude: address.latitude,
  line1: address.line1,
  line2: address.line2,
  longitude: address.longitude,
  postalCode: address.postal_code,
  state: address.state,
  formattedAddress: address.formatted_address,
  countryIsoCode: address.country_iso_code,
})

export const addShippingAddressArgsToParams = ({ address }: AddShippingAddressArgs) => ({
  entry_type: AddressEntryType.Shipping,
  country_id: address.countryId,
  name: address.name,
  country: address.country,
  city: address.city,
  line1: address.line1,
  line2: address.line2,
  postal_code: address.postalCode,
})

export const addShippingOrderAddressArgsToParams = ({
  addressId,
}: AddShippingOrderAddressArgs) => ({
  address_id: addressId,
})

export const addUserAddressArgsToParams = ({ address }: AddUserAddressArgs) => ({
  entry_type: address.entryType,
  country_id: address.countryId,
  name: address.name,
  country: address.country,
  city: address.city,
  line1: address.line1,
  line2: address.line2,
  postal_code: address.postalCode,
})

export const transformDefaultShippingAddress = ({
  user_address,
}: Response<DefaultShippingAddressResp>) => {
  if (!user_address) return null

  return transformAddress(user_address)
}
